import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { RoadmapCommitment } from '../../../services/projectRoadmapService';

function formatDay(value: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (!match) return value;
  return `${match[3]}/${match[2]}`;
}

interface RoadmapAgendaStripProps {
  items: RoadmapCommitment[];
}

/** Compromissos de roadmap marcados para o usuário. Fica acima da fila de ações. */
export const RoadmapAgendaStrip: React.FC<RoadmapAgendaStripProps> = ({ items }) => {
  const navigate = useNavigate();
  if (items.length === 0) return null;

  return (
    <div className="shrink-0 border-b border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-900/60">
      <div className="px-2 py-1 text-[9px] font-bold uppercase tracking-[0.12em] text-slate-500">
        Agenda do projeto
      </div>
      <ul>
        {items.map(item => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => navigate(`/projetos/${item.projectId}?tab=roadmap`)}
              className="flex w-full items-start gap-2 px-2 py-1.5 text-left hover:bg-white dark:hover:bg-slate-800"
            >
              <span className="mt-0.5 rounded bg-teal-50 px-1 py-0.5 text-[8px] font-bold text-teal-700 ring-1 ring-teal-100">AG</span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[11px] font-semibold text-slate-800 dark:text-slate-100">{item.title}</span>
                <span className="block truncate text-[10px] text-slate-500">
                  {item.projectName} · {formatDay(item.plannedStart)}–{formatDay(item.plannedEnd)}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
